/* eslint-disable */
import session from './session';

export default {
    getCountryList(filter) {
        return session.get(`address/country/${filter}`);
    },
    getCountry(id) {
        return session.get(`address/country/${id}/`);
    },
    deleteCountry(id) {
        return session.delete(`address/country/${id}/`);
    },
    createCountry(data) {
        return session.post(`address/country/`, data);
    },
    updateCountry(id, data) {
        return session.patch(`address/country/${id}/`, data );
    },
};